export { default as IllustrationBlob } from './IllustrationBlob'
export { IllustrationBlobType, IllustrationBlobSize } from './types'
export type {
  IllustrationBlobComponentType,
  IllustrationBlobProps,
  IllustrationBlobSizeType,
} from './types'
